import { VFC } from 'react'
import { asModal, ModalProps } from 'src/components/hoc/asModal'
import { Button, ButtonsDiv, CancelButton, Layout } from './styles'

const GroupDelete: VFC<ModalProps<{ deleteGroup: () => Promise<any> }>> = ({
  deleteGroup,
  close,
}) => (
  <Layout>
    <h3>このルームを削除しますか？</h3>
    <p>削除したルームは「削除ルーム」に分類されます</p>
    <ButtonsDiv>
      <CancelButton onClick={close}>キャンセル</CancelButton>
      <Button
        onClick={async () => {
          await deleteGroup()
          window.location.reload()
        }}
      >
        削除
      </Button>
    </ButtonsDiv>
  </Layout>
)

export const GroupDeleteModal = asModal(GroupDelete)
